document.addEventListener('DOMContentLoaded', function() {
    const playerElement = document.querySelector('.player');
    const iframeContainer = document.querySelector('.iframe');
    playerElement.addEventListener('click', function() {
        // Cria o iframe do vídeo
        const iframeElement = document.createElement('iframe');
        iframeElement.classList.add('video-yt');
        iframeElement.src = 'https://www.youtube.com/embed/' + playerElement.dataset.videoId + '?autoplay=1';
        iframeElement.title = 'Video Norte mercadológico';
        iframeElement.frameBorder = '0';
        iframeElement.allow = 'autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframeElement.referrerPolicy = 'strict-origin-when-cross-origin';
        iframeElement.allowFullscreen = true;
        // Adiciona a classe fade-out no elemento player
        playerElement.classList.add('fade-out');
        // Adiciona a classe fade-in no container do iframe
        iframeContainer.style.display = 'block';
        iframeContainer.classList.add('fade-in');
        iframeContainer.appendChild(iframeElement);
        // Configura os eventos de fim de animação
        playerElement.addEventListener('animationend', function() {
            playerElement.style.display = 'none';
            playerElement.classList.remove('fade-out');
        }, { once: true });
        iframeContainer.addEventListener('animationend', function() {
            iframeContainer.classList.remove('fade-in');
        }, { once: true });
    });
});